module.exports = __webpack_public_path__ + "static/img/浙江纵海4.4e25a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/浙江纵海4.jpg
// module id = r0cq
// module chunks = 1